export default "__VITE_ASSET__0223ecb7__"